import React from 'react'
import { useHistory } from 'react-router'
import { ArrowRight2 } from 'iconsax-react'

import { Routes } from '@SonarCX/Routes'
import useStyles from '../styles'

type ContentProps = {
  task: LocalTask & { parent: { id: string; title: string } }
  value: string
  halt: (e: any) => void
  showParentTitle: boolean
  classes: ReturnType<typeof useStyles>
}

const Content: React.FC<ContentProps> = ({
  task,
  value,
  halt,
  showParentTitle,
  classes
}) => {
  const history = useHistory()

  return (
    <div className='content'>
      {showParentTitle && (
        <>
          <span
            onClick={e => {
              halt(e)
              history.push(`${Routes.TASKS}/${task.parent.id}`)
            }}
            className={classes.parent}
          >
            {task.parent.title}
          </span>
          <ArrowRight2 variant='Bold' className={classes.arrow} />
        </>
      )}

      {value}
    </div>
  )
}

export default Content
